import { useState } from "react"
import Style from "./style"
import CollectModal from "./ui/CollectModal"

import Pagenation from "widget/Pagenation"

import useGetAccountSeedTicketList from "entity/account/useGetAccountSeedTicketList"
import useGetAccountSeedTicketRecord from "entity/account/useGetAccountSeedTicketRecord"

import DefaultButton from "shared/ui/DefaultButton"
import TStyle from "shared/style/tableStyle"
import timestampCalculator from "shared/lib/timestampCalculator"
import { convertRecordTypeAsName } from "shared/constant/lookup/recordType"
import TableLoading from "shared/ui/TableLoading"

const SeedTicket = () => {
    const [collectTicketTypeIdx, setCollectModalOpen] = useState(false)

    const [ticketList, isLoading] = useGetAccountSeedTicketList()
    const [ticketRecord, recordLoading] = useGetAccountSeedTicketRecord()

    const sizeList = ["short", "medium", "longlonglong", "expand", "short", "short"]
    const tableHeadList = ["IDX", "시리즈 IDX", "대회 시리즈", "시드권", "개수", ""]

    const recordSizeList = ["short", "longlonglong", "expand", "medium", "medium", "short", "long"]
    const recordTableHeadList = ["IDX", "대회 시리즈", "대회", "시드권", "분류", "개수", "기록 날짜"]

    return (
        <>
            {collectTicketTypeIdx && <CollectModal ticketTypeIdx={collectTicketTypeIdx} closeEvent={() => setCollectModalOpen(null)} />}

            <Style.Wrapper>

                <Style.Area>
                    <h2>보유</h2>

                    <TableLoading isLoading={isLoading}>
                        <TStyle.TableDiv>
                            <TStyle.TableInner>
                                <TStyle.TableRow $title>
                                    {tableHeadList.map((elem, index) =>
                                        <TStyle.Data key={index} $title $size={sizeList[index]}>{elem}</TStyle.Data>
                                    )}
                                </TStyle.TableRow>
                                {ticketList?.data?.seed_ticket_list?.map((elem, index) =>
                                    <TStyle.TableRow key={index} $odd={index % 2 === 1}>
                                        <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
                                        <TStyle.Data $size={sizeList[1]}>{elem?.series_idx}</TStyle.Data>
                                        <TStyle.Data $size={sizeList[2]}>{elem?.series_name}</TStyle.Data>
                                        <TStyle.Data $size={sizeList[3]}>{elem?.ticket_name}</TStyle.Data>
                                        <TStyle.Data $size={sizeList[4]}>{elem?.ticket_number}</TStyle.Data>
                                        <TStyle.Data $size={sizeList[5]}>
                                            <DefaultButton small fitWidth clickEvent={() => setCollectModalOpen(elem?.seed_ticket_type_idx)}>회수</DefaultButton>
                                        </TStyle.Data>
                                    </TStyle.TableRow>
                                )}
                            </TStyle.TableInner>
                        </TStyle.TableDiv>
                    </TableLoading>
                </Style.Area>

                <Style.Area $expand>
                    <h2>사용 기록</h2>

                    <TableLoading isLoading={recordLoading}>
                        <TStyle.TableDiv>
                            <TStyle.TableInner>
                                <TStyle.TableRow $title>
                                    {recordTableHeadList.map((elem, index) =>
                                        <TStyle.Data key={index} $title $size={recordSizeList[index]}>{elem}</TStyle.Data>
                                    )}
                                </TStyle.TableRow>
                                {ticketRecord?.data?.seed_ticket_record?.map((elem, index) =>
                                    <TStyle.TableRow key={index} $odd={index % 2 === 1}>
                                        <TStyle.Data $size={recordSizeList[0]}>{elem?.idx}</TStyle.Data>
                                        <TStyle.Data $size={recordSizeList[1]}>{elem?.series_name}</TStyle.Data>
                                        <TStyle.Data $size={recordSizeList[2]}>{elem?.event_name || "-"}</TStyle.Data>
                                        <TStyle.Data $size={recordSizeList[3]}>{elem?.ticket_name}</TStyle.Data>
                                        <TStyle.Data $size={recordSizeList[4]}>{convertRecordTypeAsName[elem?.ticket_record_type_flag]}</TStyle.Data>
                                        <TStyle.Data $size={recordSizeList[5]}>{elem?.number}</TStyle.Data>
                                        <TStyle.Data $size={recordSizeList[6]}>{timestampCalculator(elem?.created_at)}</TStyle.Data>
                                    </TStyle.TableRow>
                                )}
                            </TStyle.TableInner>
                        </TStyle.TableDiv>
                    </TableLoading>

                    <Pagenation maxPage={1} />
                </Style.Area>

            </Style.Wrapper >
        </>
    )
}

export default SeedTicket